/** Palette aligned with KPI dashboard booking / lost-reason source pies. */
export const SOURCE_PIE_CHART_COLORS = [
  '#3B82F6',
  '#10B981',
  '#F59E0B',
  '#EF4444',
  '#8B5CF6',
  '#06B6D4',
  '#F97316',
  '#84CC16',
  '#EC4899',
  '#6B7280',
] as const;

export interface SourcePieDetail {
  source: string;
  count: number;
  value: number;
  percentage: string;
}

export interface SourcePieChartPayload {
  total: number;
  sourceDetails: SourcePieDetail[];
  chartData: {
    labels: string[];
    datasets: {
      data: number[];
      backgroundColor: string[];
      borderColor: string;
      borderWidth: number;
      hoverBorderWidth: number;
    }[];
  } | null;
}

export function buildSourcePieChartPayload(
  entries: Array<{ source: string; count: number; value: number }>,
): SourcePieChartPayload {
  const sorted = [...entries].sort((a, b) => b.count - a.count);
  const total = sorted.reduce((sum, row) => sum + row.count, 0);

  if (total === 0) {
    return { total: 0, sourceDetails: [], chartData: null };
  }

  const sourceDetails: SourcePieDetail[] = sorted.map((row) => ({
    source: row.source,
    count: row.count,
    value: row.value,
    percentage: ((row.count / total) * 100).toFixed(1),
  }));

  const labels = sourceDetails.map(
    (detail) => `${detail.source} (${detail.percentage}%)`,
  );
  const data = sourceDetails.map((detail) => detail.count);
  const backgroundColor = SOURCE_PIE_CHART_COLORS.slice(0, labels.length);

  return {
    total,
    sourceDetails,
    chartData: {
      labels,
      datasets: [
        {
          data,
          backgroundColor: [...backgroundColor],
          borderColor: '#ffffff',
          borderWidth: 2,
          hoverBorderWidth: 3,
        },
      ],
    },
  };
}
